export function fontColorToLinearGradient(color) {
  switch (color) {
    case "#333333":
      return { background: "linear-gradient(180deg, #202020 0%, #A8A8A8 100%)" };
    case "#0085FF":
      return { background: "linear-gradient(180deg, #18A2FF 0%, #AADCFF 100%)" };
    case "#6E61FF":
      return { background: "linear-gradient(180deg, #CAE6FF 0%, #6171FF 100%)" };
    case "#FF2652":
      return { background: "linear-gradient(180deg, #FF6C8A 0%, #FFB5C4 100%)" };
    case "#FF6B00":
      return { background: "linear-gradient(180deg, #FFA000 0%, #FFE600 100%)" };
    case "#E41EB1":
      return { background: "linear-gradient(180deg, #E41EB1 0%, #FF99E5 100%)" };
    case "#113BD0":
      return { background: "linear-gradient(180deg, #2952E2 0%, #66C7FD 100%)" };
    default:
      return { background: "linear-gradient(180deg, #202020 0%, #A8A8A8 100%)" };
  }
}

export function fontColorToBackgroundColor(color) {
  switch (color) {
    case "#333333":
      return { background: " linear-gradient(0deg, rgba(174, 174, 174, 0.05), rgba(174, 174, 174, 0.05))" };
    case "#0085FF":
      return { background: " linear-gradient(0deg, rgba(24, 162, 255, 0.05), rgba(24, 162, 255, 0.05))" };
    case "#6E61FF":
      return { background: " linear-gradient(0deg, rgba(97, 113, 255, 0.05), rgba(97, 113, 255, 0.05))" };
    case "#FF2652":
      return { background: " linear-gradient(0deg, rgba(255, 108, 138, 0.05), rgba(255, 108, 138, 0.05))" };
    case "#FF6B00":
      return { background: " linear-gradient(0deg, rgba(255, 160, 0, 0.05), rgba(255, 160, 0, 0.05))" };
    case "#E41EB1":
      return { background: " linear-gradient(0deg, rgba(228, 30, 177, 0.08), rgba(228, 30, 177, 0.08))" };
    case "#113BD0":
      return { background: "linear-gradient(0deg, rgba(17, 59, 208, 0.08), rgba(17, 59, 208, 0.08))" };
    default:
      return { background: " linear-gradient(0deg, rgba(174, 174, 174, 0.05), rgba(174, 174, 174, 0.05))" };
  }
}

export function levelToLinearGradient(level) {
  if (level >= 0 && level < 2) {
    return { background: "linear-gradient(180deg, #202020 0%, #A8A8A8 100%)" };
  }
  if (level >= 2 && level < 8) {
    return { background: "linear-gradient(180deg, #18A2FF 0%, #AADCFF 100%)" };
  }
  if (level >= 8 && level < 16) {
    return { background: "linear-gradient(180deg, #CAE6FF 0%, #6171FF 100%)" };
  }
  if (level >= 16 && level < 21) {
    return { background: "linear-gradient(180deg, #FF6C8A 0%, #FFB5C4 100%)" };
  }
  if (level >= 21) {
    return { background: "linear-gradient(180deg, #FFA000 0%, #FFE600 100%)" };
  }
}

export function levelToFontColor(level) {
  if (level >= 0 && level < 2) {
    return { color: "#333333" };
  }
  if (level >= 2 && level < 8) {
    return { color: "#0098FF" };
  }
  if (level >= 8 && level < 16) {
    return { color: "#5669FF" };
  }
  if (level >= 16 && level < 21) {
    return { color: "#F34F4F" };
  }
  if (level >= 21) {
    return { color: "#FFA400" };
  }
}
